
const state = () => ({
  condition:"",
  year:null,
})

// getters
const getters = {
  condition:(state)=>{
        return state.condition
    },
  report:(state)=>{
        return state.year
    }
}

// actions
const actions = {

}

// mutations
const mutations = {
  esgCondition(state, {condition}){
    state.condition = condition
  },
  esgReport(state, {year}){
    state.year = year
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/esg.js